import { Component, OnDestroy, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AssistantPopoverService } from '../../../common/assistant-popover.service';
import { ValidationService } from '../../../common/validation.service';
import { leapDayValidator } from '../../../common/validators';
import { ValueListsService } from '../../../common/value-lists.service';
import { ValueListItem } from '../../../models/rest/valuelist/valuelist';
import { VisumErfassungSubFormComponent } from '../visum-erfassung-sub-form/visum-erfassung-sub-form.component';

@Component({
  selector: 'app-verwandter',
  templateUrl: './verwandter.component.html',
  styleUrls: ['./verwandter.component.scss']
})
export class VerwandterComponent extends VisumErfassungSubFormComponent implements OnInit, OnDestroy {
  private staatsangehoerigkeitListItemsSub: Subscription;

  staatsangehoerigkeitListItems: ValueListItem[];

  private verwandschaftsbeziehungListItemsSub: Subscription;
  verwandschaftsbeziehungListItems: ValueListItem[];


  constructor(fb: FormBuilder,
              private valueListsService: ValueListsService,
              private validationService: ValidationService,
              assistantPopoverService: AssistantPopoverService,
              @Optional() @Self() controlDir: NgControl) {
    super(controlDir, assistantPopoverService);

    this.form = this.wrapFormGroup(fb.group({
      verwandschaftsbeziehung: [null, validationService.getValidators('referenz.verwandtschaftsbeziehungBeiEUFreizuegigkeit.value')],
      familienname: [null, validationService.getValidatorsAndRequired('referenz.ansprechpartner.familienname')],
      vorname: [null, validationService.getValidatorsAndRequired('referenz.ansprechpartner.vorname')],
      geburtsdatum: [null, [...validationService.getValidatorsAndRequired('referenz.ansprechpartner.geburtsdatum'), leapDayValidator]],
      staatsangehoerigkeit: [null, validationService.getValidatorsAndRequired('referenz.ansprechpartner.staatsangehoerigkeit')],
      passnummer: [null, validationService.getValidatorsAndRequired('referenz.passnummer')]
    }));
  }

  ngOnInit() {

    super.ngOnInit();

    this.staatsangehoerigkeitListItemsSub = this.valueListsService.getValueListItems('staatsangehoerigkeit')
    .subscribe((listItems: ValueListItem[]) => this.staatsangehoerigkeitListItems = listItems);

    this.verwandschaftsbeziehungListItemsSub = this.valueListsService.getValueListItems('verwandtschaftsbeziehung')
      .subscribe((listItems: ValueListItem[]) => this.verwandschaftsbeziehungListItems = listItems);
  }

  ngOnDestroy(): void {
    this.staatsangehoerigkeitListItemsSub.unsubscribe();
    this.verwandschaftsbeziehungListItemsSub.unsubscribe();
  }
}
